module.exports = __webpack_public_path__ + "img/signature.f698abd4.png";